import 'css-chunksrc/client/scenes/wbs/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_kwnvz_1"
};